/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { Component } from 'react';

// Styles
import './styles/DebugLinks.scss';

class DebugLinks extends Component {
  constructor(props) {
    super(props);

    this.links = [
      {
        link: '/selvitys/US/0139506-7',
        name: 'Väärä maakoodi',
      },
      {
        link: '/selvitys/FI/1234567-8',
        name: 'Ei ole olemassa',
      },
      {
        link: '/selvitys/FI/0139506-7',
        name: 'Monta toiminimeä',
      },
      {
        link: '/selvitys/FI/2609967-8',
        name: 'Konkurssissa',
      },
      {
        link: '/selvitys/FI/0100032-8',
        name: 'Luotettava Kumppani',
      },
      {
        link: '/selvitys/FI/1969604-4',
        name: 'Luotettava Kauneus',
      },
      {
        link: '/selvitys/FI/2558143-8',
        name: 'Omaduunari',
      },
      {
        link: '/selvitys/FI/0963299-5',
        name: 'Kodin sähkötyöt',
      },
      {
        link: '/selvitys/FI/0186105-6',
        name: 'SETI',
      },
      {
        link: '/selvitys/FI/1905510-8',
        name: 'Liiketoimintakielto',
      },
    ];
  }

  render() {
    return (
      <div styleName="DebugLinks">
        <div className="main pure-g">
          <div className="pure-u-1-24 hidden-mobile no-print" />
          <div className="pure-u-1-1 pure-u-lg-22-24 pure-u-1-1-print">
            {this.links.map(link => (
              <div key={link.name}>
                <a href={link.link}>{link.name}</a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default DebugLinks;
